/**
 * AppealSlice State Definition
 * 
 * Defines the state interface and initial state for the appeal slice.
 */

import { AppealLetterView, PolicyReferenceView } from '../types/appealTypes';

/**
 * State interface for the appeal slice.
 * Follows the standard BaseSliceState pattern with appeal-specific naming.
 */
export interface AppealSliceState {
  /** The current appeal being viewed/edited, or null if none selected */
  currentAppeal: AppealLetterView | null;
  /** Whether the appeal is in editing mode */
  isEditing: boolean;
  /** Whether any edits have been made since loading/saving */
  hasUnsavedChanges: boolean;
  /** List of selected policy references for the current appeal */
  selectedPolicyReferences: PolicyReferenceView[];
  /** Whether AI generation is in progress */
  generationInProgress: boolean;
  /** Error message, or null if no error */
  error: string | null;
}

/**
 * Initial state for the appeal slice.
 */
export const initialState: AppealSliceState = {
  currentAppeal: null,
  isEditing: false,
  hasUnsavedChanges: false,
  selectedPolicyReferences: [],
  generationInProgress: false,
  error: null,
};
